import type { Component } from 'vue';
import PlayerButton from './PlayerButton.vue';

export default new Map<string, Component>([
  ['PlayerButton', PlayerButton],
]);



